var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "single__documents container-max" }, [
    _vm.currentVariation && _vm.currentVariation.item.free1
      ? _c(
          "a",
          {
            attrs: {
              target: "_blank",
              title: _vm.$translate("Weberbuero::Template.singlePDFCatalog"),
              href: _vm.currentVariation.item.free1
            }
          },
          [
            _c("svg", { attrs: { width: "28", height: "35" } }, [
              _c("use", {
                attrs: {
                  "xlink:href": "#svg_pdf-download",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                }
              })
            ]),
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$translate("Weberbuero::Template.singlePDFCatalog")
                ) +
                "\n    "
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.currentVariation && _vm.currentVariation.item.free3
      ? _c(
          "a",
          {
            attrs: {
              target: "_blank",
              title: _vm.$translate("Weberbuero::Template.singlePDFCatalog2"),
              href: _vm.currentVariation.item.free3
            }
          },
          [
            _c("svg", { attrs: { width: "28", height: "35" } }, [
              _c("use", {
                attrs: {
                  "xlink:href": "#svg_pdf-download",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                }
              })
            ]),
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$translate("Weberbuero::Template.singlePDFCatalog2")
                ) +
                "\n    "
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.currentVariation && _vm.currentVariation.item.free13
      ? _c(
          "a",
          {
            attrs: {
              target: "_blank",
              title: _vm.$translate(
                "Weberbuero::Template.singlePDFCatalogMontage"
              ),
              href: _vm.currentVariation.item.free13
            }
          },
          [
            _c("svg", { attrs: { width: "28", height: "35" } }, [
              _c("use", {
                attrs: {
                  "xlink:href": "#svg_pdf-download",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                }
              })
            ]),
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$translate("Weberbuero::Template.singlePDFCatalogMontage")
                ) +
                "\n    "
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }